<template>
  <div class="columns is-mobile">
    <div class="column dashboard__menu">
      <div class="sidebar sidebar--static">
        <div class="inner">
          <ul class="sidebar-menu">
            <li title="Quản lý phòng họp">
              <router-link
                :to="'/ongoing-conference-list'"
                class="polycom-link">
                <img src="@/assets/images/icons/icon-conf_control.png" alt="Quản lý phòng họp">
                <span class="is-block polycom-link-text">Quản lý phòng họp</span>
              </router-link>
            </li>
            <li title="Quản lý người dùng">
              <router-link
                :to="'/user-management'"
                class="polycom-link">
                <img src="@/assets/images/icons/icon-address.png" alt="Quản lý người dùng">
                <span class="is-block polycom-link-text">Quản lý người dùng</span>
              </router-link>
            </li>
            <li title="Tạo lịch họp">
              <router-link
                :to="'/calendar'"
                class="polycom-link">
                <img src="@/assets/images/icons/icon-schedule.png" alt="Tạo lịch họp">
                <span class="is-block polycom-link-text">Tạo lịch họp</span>
              </router-link>
            </li>
            <li title="Lọc người tham gia phòng họp">
              <router-link
                :to="'/passcode-room-management'"
                class="polycom-link is-active">
                <img src="@/assets/images/icons/icon-reservation.png" alt="Lọc người tham gia phòng họp">
                <span class="is-block polycom-link-text">Lọc người tham gia phòng họp</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="column content-management">
      <div class="roomList">
        <div class="breadcrumb-wrapper">
          <img src="@/assets/images/icons/icon-home.png" alt="" class="icon-home">
          <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
            <ul>
              <li><router-link to="/index">Trang chủ</router-link></li>
              <li class="is-active"><a>Gửi Thông Tin Phòng Họp</a></li>
            </ul>
          </nav>
        </div>
        <div v-if="roomList && Object.keys(roomList).length" class="content-tab-passcode">
          <div class="content-tab">
            <div class="card-heading-tab"><span class="card-icon-tab"><img src="@/assets/images/icons/icon-meeting.png"></span><span class="card-text">Danh sách các phòng họp</span></div>
            <table class="table is-fullwidth userList__table">
              <tbody>
                <tr v-for="(room, index) in roomList" :key="room.roomIdentifier" :class="{'is-odd': index%2 !== 0}">
                  <td class="has-text-left table-room-id">{{room.roomIdentifier}}</td>
                  <td class="has-text-right">
                    <div class="columns">
                      <div class="column has-text-center">
                        <span class="roomList__passcode">{{room.passCode|| 'Không có'}}</span>
                        <b-button
                          type="is-danger"
                          @click="openResetPassCodeModal(room)"
                          class="roomList__btn-new"
                          v-if="room.passCode"
                        >Xoá</b-button>
                        <b-button
                          type="is-info"
                          @click="openPassCodeModal(room)"
                          class="roomList__btn-new"
                        >Thay đổi</b-button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="content-tab">
            <div class="card-heading-tab"><span class="card-icon-tab"><img src="@/assets/images/icons/icon-meeting.png"></span><span class="card-text">Tạo danh sách tham gia phòng họp</span></div>
            <div class="content-wrapper">
              <form @submit.prevent="sendPassCodeFunc" data-vv-scope="roomInfo">
              <div class="form-row mb-20">
                <b-field
                  :type="{'is-danger': errors.has('roomInfo.title')}"
                  :message="errors.first('roomInfo.title')"
                  custom-class="has-text-weight-normal"
                >
                  <template slot="label">
                    Chủ đề cuộc họp <span class="has-text-danger">*</span>
                  </template>
                  <b-input
                    v-model="roomTitle"
                    v-validate ="'required'"
                    name="title"
                    data-vv-as="Chủ đề cuộc họp"/>
                </b-field>
              </div>
              <div class="form-row mb-20">
                <b-field
                  :type="{'is-danger': errors.has('roomInfo.roomId')}"
                  :message="errors.first('roomInfo.roomId')"
                  custom-class="has-text-weight-normal"
                  :class="{'danger-field': errors.has('roomInfo.roomId')}"
                >
                  <template slot="label">
                    Danh sách phòng họp <span class="has-text-danger">*</span>
                  </template>
                  <v-select
                    v-model="chosenRoomInfo"
                    label="roomIdentifier"
                    :options="roomListDropdown"
                    name="roomId"
                    v-validate ="'required'"
                    data-vv-as="Phòng họp"/>
                </b-field>
              </div>
              <div class="form-row">
                <b-field
                  :type="{'is-danger': errors.has('roomInfo.users')}"
                  :message="errors.first('roomInfo.users')"
                  custom-class="has-text-weight-normal"
                >
                  <template slot="label">
                    Danh sách người dùng sẽ tham gia <span class="has-text-danger">*</span>
                  </template>
                  <div class="table userList__table">
                    <div class="username__wrapper" @click="selectAllParties">
                      <input type="checkbox" class="username__input" :checked="getAllCheckedParties"> <span class="username__text">Tất cả</span></div>
                    <div class="userList__table__limit">
                      <div
                        v-for="(user, index) in selectedParticipants"
                        :key="user.name"
                        :class="{'is-odd': !(index%2)}"
                        @click="selectParty(user)"
                      >
                        <div class="username__wrapper">
                          <input
                            type="checkbox"
                            class="username__input"
                            :checked="user.checked"
                            name="users"
                            v-validate ="'required'"
                            data-vv-as="Người dùng phòng họp"> <span class="username__text">{{user.firstName}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-field>
                <b-button
                  type="is-info"
                  class="roomList__btn-send-passcode"
                  native-type="submit"
                  :disabled="isSendPassCodeLoading"
                >Tạo</b-button>
              </div>
              </form>
            </div>
          </div>
          <div class="content-tab">
            <div class="card-heading-tab"><span class="card-icon-tab"><img src="@/assets/images/icons/icon-meeting.png"></span><span class="card-text">Thông tin phòng họp đã đăng ký</span></div>
            <div class="content-wrapper booked-room">
              <div class="columns">
                <div class="column is-two-fifths has-text-weight-bold booked-order">STT</div>
                <div class="column is-two-fifths has-text-weight-bold">Danh sách</div>
                <div class="column has-text-weight-bold">Phòng họp</div>
                <div class="column is-one-third has-text-weight-bold">Ngày</div>
                <div class="column"></div>
              </div>
              <div v-for="(roomInfo, index) in bookedRoomList" :key="roomInfo._id" class="columns">
                <div class="column booked-order">{{index}}</div>
                <div class="column is-two-fifths">
                  <span class="tag is-success booked-room__user" v-for="(party, index) in roomInfo.participants" :key="index">{{party}}</span>
                </div>
                <div class="column">
                  {{roomInfo.room}}
                </div>
                <div class="column is-one-third">
                  {{roomInfo.title}}
                </div>
                <div class="column">
                  <button
                    class="button delete is-danger button-delete-booked-parties"
                    aria-label="close"
                    @click="openDeleteFilterRoomModal(roomInfo._id, roomInfo.room)"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <p class="title is-6" style="text-align: center">
            <img class="loading" src="@/assets/images/icons/loading.gif" alt="Loading">
          </p>
        </div>
        <b-modal :active.sync="isOpenPassCodeModal">
          <div class="content-layout content-layout--passcode">
            <header class="modal-card-head"><p class="modal-card-title">Tạo mật khẩu phòng họp {{selectedRoom&&selectedRoom.id}}</p><button aria-label="close" class="delete" @click="isOpenPassCodeModal=false"></button></header>
            <div class="content-layout__inner">
              <div class="body-text">Xin xác nhận thay đổi mật khẩu phòng họp?</div>
            </div>
            <div class="modal-bottom-group field is-grouped is-grouped-centered">
              <div class="control">
                <b-button @click="isOpenPassCodeModal=false">Đóng</b-button>
              </div>
              <div class="control">
                <b-button type="is-info" @click="createPasscode">Thay đổi</b-button>
              </div>
              
            </div>
          </div>
        </b-modal>
        <b-modal :active.sync="isResetPassCodeModal">
          <div class="content-layout content-layout--passcode">
            <header class="modal-card-head"><p class="modal-card-title">Xoá mật khẩu phòng họp {{selectedRoom&&selectedRoom.id}}</p><button aria-label="close" class="delete" @click="isResetPassCodeModal=false"></button></header>
            <div class="content-layout__inner">
              <div class="body-text">Xin xác nhận xoá mật khẩu phòng họp?</div>
            </div>
            <div class="modal-bottom-group field is-grouped is-grouped-centered">
              <div class="control">
                <b-button @click="isResetPassCodeModal=false">Đóng</b-button>
              </div>
              <div class="control">
                <b-button type="is-danger" @click="deletePasscode">Xoá</b-button>
              </div>
            </div>
          </div>
        </b-modal>
        <b-modal :active.sync="isDeleteFilterRoomModal">
          <div class="content-layout content-layout--passcode">
            <header class="modal-card-head"><p class="modal-card-title">Xoá lọc phòng họp {{selectedFilterRoomID}}</p><button aria-label="close" class="delete" @click="isDeleteFilterRoomModal=false"></button></header>
            <div class="content-layout__inner">
              <div class="body-text">Xin xác nhận xoá lọc phòng họp?</div>
            </div>
            <div class="modal-bottom-group field is-grouped is-grouped-centered">
              <div class="control">
                <b-button @click="isDeleteFilterRoomModal=false">Đóng</b-button>
              </div>
              <div class="control">
                <b-button type="is-danger" @click="removeBookedPartiesFunc">Xoá</b-button>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import vSelect from "vue-select"
Vue.component('v-select', vSelect)

export default {
  data() {
    return {
      isOpenPassCodeModal: false,
      newPasscode: 0,
      selectedRoom: null,
      roomIds: [],
      chosenRoomInfo: null,
      selectedParticipants: [],
      isSendPassCodeLoading: false,
      roomTitle: new Date().toLocaleString(),
      isResetPassCodeModal: false,
      isDeleteFilterRoomModal: false,
      selectedFilterConfID: null,
      selectedFilterRoomID: null
    };
  },
  created() {
    this.$store.dispatch("room/getRooms", this.$store.state.auth.username).then(() => {
      this.roomIds = this.roomList.map(room => room.roomIdentifier)
    });
    this.getParticipants(this.$store.state.auth.entityTag);
    this.getBookedRooms()
  },
  methods: {
    ...mapActions("participant", [
      "getParticipants"]),
    ...mapActions("room", ["sendPassCode", "getBookedRooms", "removeBookedRooms"]),
    // manage room
    openPassCodeModal(room) {
      const newRoom = { ...room };
      this.selectedRoom = {
        id: newRoom.roomIdentifier,
        entityTag: newRoom.entityTag
      };
      this.isOpenPassCodeModal = true;
    },
    createPasscode() {
      const username = this.$store.state.auth.username;
      if (this.selectedRoom) {
        this.$store
          .dispatch("room/randomPasscode", {
            username,
            room: this.selectedRoom
          })
          .then(res => {
            if (res.data.status) {
              this.$toast.open({
                message: "Thay đổi mật khẩu phòng thành công",
                type: "is-info"
              });
            } else {
              this.$toast.open({
                message: "Thay đổi mật khẩu phòng không thành công",
                type: "is-danger"
              });
            }
          });
      }
      this.selectedRoom = null;
      this.isOpenPassCodeModal = false;
    },
    deletePasscode() {
      const username = this.$store.state.auth.username;
      const newRoom = {
        id: this.selectedRoom.id,
        entityTag: this.selectedRoom.entityTag
      };
      if (newRoom) {
        this.$store
          .dispatch("room/deletePasscode", {
            username,
            room: newRoom,
            passCode: ""
          })
          .then(res => {
            if (res.data.status) {
              this.$toast.open({
                message: "Xoá mật khẩu phòng thành công!",
                type: "is-info"
              });
            } else {
              this.$toast.open({
                message: "Xoá mật khẩu phòng không thành công!",
                type: "is-danger"
              });
            }
          });
        this.selectedRoom = null;
        this.isResetPassCodeModal = false;
      }
    },
    selectParty(data) {
      this.selectedParticipants = [...this.selectedParticipants.map(user => {
        if(user.name === data.name) {
          user.checked = !user.checked
        }
        return user
      })]
    },
    selectAllParties() {
      if(this.getAllCheckedParties) {
        this.selectedParticipants = [...this.selectedParticipants.map(user => {
          user.checked = false
          return user
        })]
      } else {
        this.selectedParticipants = [...this.selectedParticipants.map(user => {
          user.checked = true
          return user
        })]
      }
    },
    validateBeforeSend() {
      return this.$validator.validateAll('roomInfo')
    },
    sendPassCodeFunc() {
      this.validateBeforeSend().then((result) => {
        if(result) {
          this.isSendPassCodeLoading = true
          this.sendPassCode({
            title: this.roomTitle,
            username: this.$store.state.auth.username,
            room: this.chosenRoomInfo.roomIdentifier,
            passCode: this.chosenRoomInfo.passCode,
            participants: this.selectedParticipants.filter(user => user.checked).map(user => user.firstName)
          }).then((res) => {
            if(res.data.status) {
              this.getBookedRooms()
              this.$toast.open({
                type: 'is-info',
                message: res.data.message
              })
            } else {
              this.$toast.open({
                type: 'is-danger',
                message: res.data.message
              })
            }
          }).catch((err) => {
            this.$toast.open({
              type: 'is-danger',
              message: err
            })
          }).finally(() => {
            this.isSendPassCodeLoading = false
            this.resetPassCodeFunc()
          })
        }
      })
    },
    resetPassCodeFunc() {
      this.chosenRoomInfo = null
      this.selectedParticipants = [...this.selectedParticipants.map(user => {
        user.checked = false
        return user
      })]
      this.roomTitle = new Date().toLocaleString()
    },
    removeBookedPartiesFunc() {
      this.removeBookedRooms({id: this.selectedFilterConfID}).then(res => {
        if(res.data.status) {
          this.$toast.open({
            type: 'is-info',
            message: res.data.message
          })
        } else {
          this.$toast.open({
            type: 'is-danger',
            message: res.data.message
          })
        }
      }).finally(() => {
        this.isDeleteFilterRoomModal = false
        this.selectedFilterConfID = null
        this.selectedFilterRoomID = null
      })
    },
    openResetPassCodeModal(room) {
      this.isResetPassCodeModal = true;
      this.selectedRoom = {
        id: room.roomIdentifier,
        entityTag: room.entityTag
      };
    },
    openDeleteFilterRoomModal(id, roomID) {
      this.isDeleteFilterRoomModal = true;
      this.selectedFilterConfID = id
      this.selectedFilterRoomID = roomID
    }
  },
  computed: {
    ...mapState("room", ["roomList", "bookedRoomList"]),
    ...mapState("participant", ["userList"]),
    getAllCheckedParties() {
      return this.selectedParticipants.every(user => user.checked)
    },
    roomListDropdown() {
      return this.roomList
    }
  },
  watch: {
    userList() {
      this.selectedParticipants = this.userList.map(user => {
        const data = user
        data.checked = false
        return data
      })
    },
    roomList() {
      this.chosenRoomInfo = null
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scope>
@import "@/assets/scss/partials/_colors.scss";
@import "@/assets/scss/form.scss";
.roomList {
  padding-left: 0;
  padding-right: 0;

  .roomList__btn-new {
    vertical-align: middle;
    margin-left: 10px;
  }

  .roomList__btn-send-passcode {
    margin-top: 15px;
  }

  &__passcode {
    display: inline-block;
    vertical-align: middle;
  }
  &__heading {
    width: 100px;
  }
  .multiselect__tags {
    padding-top: 5px;
  }
  .multiselect__placeholder {
    margin-bottom: 0;
    padding-top: 4px;
  }
}
.link {
  color: #666;
}
.form-row {
  margin-top: 10px;
}
.button-delete-booked-parties {
  border-radius: 100%;
}
</style>
